// login-not-possible.component.ts

import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '@app/auth/auth.service';

@Component({
	selector: 'app-login-not-possible',
	template: `
		<div class="container">
			<mat-card>
				<mat-card-header>
					<mat-card-title>Login Not Possible</mat-card-title>
				</mat-card-header>
				<mat-card-content>
					<p>We're sorry, but we couldn't log you in at this time.</p>
					<p>Please try again or contact support if the problem persists.</p>
				</mat-card-content>
				<mat-card-actions>
					<button mat-raised-button color="primary" (click)="retryLogin()">Retry Login</button>
				</mat-card-actions>
			</mat-card>
		</div>
	`,
	styles: [`
    .container {
      display: flex;
      justify-content: center;
      align-items: center;
      height: 100vh;
      background-color: #f5f5f5;
    }
    mat-card {
      max-width: 400px;
      width: 100%;
      text-align: center;
    }
    mat-card-header {
      justify-content: center;
    }
    mat-card-title {
      margin-bottom: 16px;
    }
    mat-card-content {
      margin-bottom: 16px;
    }
    button {
      width: 100%;
    }
  `]
})
export class LoginNotPossibleComponent {
	constructor(private authService: AuthService, private router: Router) {}

	retryLogin() {
		this.router.navigate(['/']);
	}
}
